import { CalendarClock, CheckCircle2, Hourglass, Users } from "lucide-react";
import { StatCard } from "@/components/common";
import { brl } from "@/lib/api";
import { ReferralLinkCard } from "@/components/referrals/ReferralLinkCard";
import { PixKeyForm } from "@/components/referrals/PixKeyForm";
import { PayoutsList, ReferralsList } from "@/components/referrals/ReferralTables";

function Stats({ s }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard label="Indicações ativas" value={s.active_referrals} icon={Users} hint={`${s.total_referrals} no total`} testId="referral-stat-active" />
      <StatCard label="Comissões no período" value={brl(s.period_amount)} icon={CalendarClock} hint={s.period_label} tone="success" testId="referral-stat-period" />
      <StatCard label="A receber" value={brl(s.pending_amount)} icon={Hourglass} hint="Fechamentos aguardando pagamento" tone="warning" testId="referral-stat-pending" />
      <StatCard label="Total recebido" value={brl(s.paid_amount)} icon={CheckCircle2} hint="Pagamentos já feitos" testId="referral-stat-paid" />
    </div>
  );
}

export function ReferralPanel({ data, onSavePix }) {
  return (
    <div className="space-y-6" data-testid="referral-panel">
      <ReferralLinkCard link={data.link} program={data.program} />
      <Stats s={data.stats} />
      <PixKeyForm key={data.referrer.pix_key} value={data.referrer.pix_key} onSave={onSavePix} />
      <ReferralsList rows={data.referrals} />
      <PayoutsList rows={data.payouts} />
    </div>
  );
}
